import styled from 'styled-components';

import BlockRenderer from 'components/sanity-block-renderer';

const margin = '0 0 1rem 0';
const padding = '0';
const fontStyle = 'normal';
const fontSize = '1rem';
const lineHeight = '1.2';

const Disclaimer = styled(BlockRenderer)`
  margin: ${margin};
  padding: ${padding};
  text-align: center;
  font-size: ${fontSize};
  color: ${Styles.color.black};
  font-family: ${Styles.fontFamily.base};
  font-weight: ${Styles.fontWeight.normal};
  line-height: ${lineHeight};
  margin: 0.5rem 0 1.75rem 0;
  p {
    font-style: ${fontStyle};

    ${Styles.mobile`
      font-size:1rem;
    `}
    ${Styles.desktop`
      font-size:1rem;
    `}
  }
`;

export const DisclaimerPlain = styled.p`
  margin: ${margin};
  padding: ${padding};
  text-align: center;
  font-size: ${fontSize};
  color: ${Styles.color.black};
  font-family: ${Styles.fontFamily.body};
  margin-top: 1rem;
  font-style: ${fontStyle};
  font-weight: ${Styles.fontWeight.normal};
  line-height: ${lineHeight};
`;

export default Disclaimer;
